import { Component, OnInit } from '@angular/core';

// Local library
import { WithdrawWireTransferService } from '@amwager/funding/data-access';
import { TranslatePipe } from '@amwager/util';

@Component({
  selector: 'feature-mat-withdraw-wire-transfer',
  templateUrl: './wire-transfer.component.html',
  styleUrls: ['./wire-transfer.component.scss'],
  standalone: true,
  imports: [TranslatePipe],
  providers: [WithdrawWireTransferService],
})
export class WireTransferComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    null;
  }

}
